import React, {memo} from "react";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionAddItemInInvoice,
    actionChangeLoaderInvoiceModalShoppingCard,
    actionChangePayTypeClickInvoice,
    actionHandelRemoveAllItemInBasketCart,
    actionRemoveItemInInvoice,
    handelArrowModalShoppingCard,
    handelChangeLevelPaymentModalShoppingCard,
    handelCloseModalShoppingCard,
    handelToggleAnimationModalShoppingCard,
    actionRefreshModalShoppingCard
} from "../../../../../../redux/actions/modals/modalShoppingCard";
import axios from "axios";
import {BASE_URL, ORDERS_REGISTER_POST, PAYMENT_PAY, PAYMENT_EDIT_ORDER_PAY, ORDERS_EDIT_POST, PUBLIC_URL_SERVER} from "../../../../../../apis";
import qs from "querystring";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {
    actionChangeHandelModalAddDiscountCode, actionChangeInputsModalAddDiscountCode,
    actionRefreshModalAddDiscountCode
} from "../../../../../../redux/actions/modals/modalAddDiscountCode";
import {useRouteMatch, useHistory} from "react-router-dom";
import {FaPlus} from "react-icons/all";

const InvoiceFooter = () => {
    const dispatch = useDispatch();
    const match = useRouteMatch();
    let history = useHistory();
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {statusSet, amount, discountCode} = useSelector(state => state.modalAddDiscountCode);
    const {
        statusAnimation, invoice, activeSelectTablePostSchedule,
        activeDayPostSchedule, orderDescription,
        selectableQuestion, statusLoaderPrice, payTypeClick,
    } = useSelector(state => state.modalShoppingCard);
    const {carts} = useSelector(state => state.shoppingCart);

    const {activeAddress, token} = useSelector(state => state.user);

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });

    const handelToggleAnim = () => {
        dispatch(handelToggleAnimationModalShoppingCard(!statusAnimation));
    };

    const handelOnlinePaymentShoppingCard = () => {
        handleOrderApiOk(2);
    };

    const handelAddressPaymentShoppingCard = () => {
        handleOrderApiOk(1);
    };


    /* in func age true bargardoone yani "kasr az kife pool" dar factor nist va barax */
    const statusAddWalletItemInInvoice = () => {
        for (const key in invoice.items) {
            if (Object.keys(invoice.items[key]).toString() === 'پرداخت از کیف پول') {
                return false;
            }
        }
        return true;
    }


    const handelWalletPaymentShoppingCard = () => {
        const buttonsOkCancel = Swal.mixin({
            customClass: {
                confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                cancelButton: 'base-btn-green-border btn btn-success',
            },
            buttonsStyling: false
        });



        if (invoice.total_raw > invoice.wallet_credit || !statusAddWalletItemInInvoice()) {
            let STATUS_SET_ITEM = true;
            for (const key in invoice.items) {
                console.log("key: " + key);
                if (Object.keys(invoice.items[key]).toString() === 'پرداخت از کیف پول') {
                    buttonsOkCancel.fire({
                        html: 'پرداخت بخشی از مبلغ از طریق کیف پول <span style="color: red;">لغو</span> شود؟',
                        imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                        imageHeight: 45,
                        imageAlt: 'فروت مروت',
                        confirmButtonText: "بله",
                        showCancelButton: true,
                        cancelButtonText: 'خیر',
                    }).then((result) => {
                        if (result.isConfirmed)
                            dispatch(actionRemoveItemInInvoice('پرداخت از کیف پول', invoice.items[key][Object.keys(invoice.items[key]).toString()]));
                    });
                    
                    STATUS_SET_ITEM = false;
                    break;
                }
            }
            if (STATUS_SET_ITEM) {
                // eslint-disable-next-line
                buttonsOkCancel.fire({
                    text: "پرداخت بخشی از مبلغ از طریق کیف پول انجام شود؟",
                    imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                    imageHeight: 45,
                    imageAlt: 'فروت مروت',
                    confirmButtonText: "بله",
                    showCancelButton: true,
                    cancelButtonText: 'خیر',
                }).then((result) => {
                    if (result.isConfirmed)
                        dispatch(actionAddItemInInvoice({['پرداخت از کیف پول']: invoice.wallet_credit}));
                });
                
            }
        } 
        else
            buttonsOkCancel.fire({
                text: "پرداخت از کیف پول انجام شود؟",
                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                imageHeight: 45,
                imageAlt: 'فروت مروت',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'خیر',
            }).then((result) => {
                if (result.isConfirmed)
                    handleOrderApiOk('wallet');
            });
            
    };

    const handelPrevLevelShoppingCard = () => {
        dispatch(handelArrowModalShoppingCard('prev'));
        setTimeout(() => {
            dispatch(handelChangeLevelPaymentModalShoppingCard('QUESTIONS', ''));
            dispatch(actionRefreshModalAddDiscountCode());
        }, 400);
        setTimeout(() => {
            handelToggleAnim();
        }, 100);
    };

    const handleOrderApiOk = (payType) => {
        dispatch(actionChangePayTypeClickInvoice(payType));
        dispatch(actionChangeLoaderInvoiceModalShoppingCard(true));
        let data = {
            store: store.id,
            address: activeAddress.addressId, delivery_time: activeSelectTablePostSchedule.id,
            pay_type: payType,
            delivery_date: activeDayPostSchedule,
            description: orderDescription,
            questions: '',
        };
        let count = 1;
        for (const cart in carts) {
            data = carts[cart].optionSelect !== undefined ? {
                ...data,
                [`grades[${count}]`]: `${carts[cart].grades[0].gradeId}`,
                [`amount[${count}]`]: `${carts[cart].w_numbers}`,
                [`for_food_pack[${count}]`]: `${carts[cart].grades[0].forFoodPack !== undefined ? carts[cart].grades[0].forFoodPack : 0}`,
                [`options[${count}]`]: `${carts[cart].optionSelect.id}`
            } : {
                ...data,
                [`grades[${count}]`]: `${carts[cart].grades[0].gradeId}`,
                [`amount[${count}]`]: `${carts[cart].w_numbers}`,
                [`for_food_pack[${count}]`]: `${carts[cart].grades[0].forFoodPack !== undefined ? carts[cart].grades[0].forFoodPack : 0}`,
            };
            count++;
        }
        for (const key in selectableQuestion) {
            if (selectableQuestion[key].question !== 'reward') {
                data = {
                    ...data,
                    'questions': `${data.questions + (data.questions.length > 0 ? ',' : '') + selectableQuestion[key].answerId}`
                };
            } else if (selectableQuestion[key].question === 'reward') {
                data = {...data, 'gratuity': selectableQuestion[key].answerTitle};
            }
        }


        let statusAddItemWallet = false;
        for (const key in invoice.items) {
            if (Object.keys(invoice.items[key]).toString() === 'پرداخت از کیف پول') {
                statusAddItemWallet = Object.keys(invoice.items[key]).toString();
                break;
            } else {
                statusAddItemWallet = false;
            }
        }
        if (statusAddItemWallet)
            data = {...data, wallet_pay: 'part'};

        if (statusSet) {
            data = {...data, discount_code: discountCode}
        }

        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
            data = {...data, order: localStorage.getItem("editOrderMode")};

        axios({
            method: 'post',
            url: BASE_URL + (localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null ? ORDERS_EDIT_POST : ORDERS_REGISTER_POST),
            data: qs.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response => {
            if (response.data.status === 'ok') {
                switch (payType) {
                    case 'wallet':
                        handleClose();
                        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
                        {
                            // swal({
                            //     title: "ثبت موفق تغییرات",
                            //     text: `پرداخت فاکتور ${response.data.order} از کیف پول با موفقیت انجام شد`,
                            //     buttons: {
                            //         cancel: "تایید",
                            //     },
                            //     icon: "success",
                            // });
                            // localStorage.removeItem("editOrderMode");
                            okPaymentEdit(response.data.order);
                        } 
                        else
                            btnOkSingle.fire({
                                title: "سفارش با موفقیت ثبت شد",
                                text: `پرداخت فاکتور ${response.data.order} از کیف پول با موفقیت انجام شد`,
                                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                                imageHeight: 45,
                                imageAlt: 'فروت مروت',
                                confirmButtonText: "تایید",
                            });
                        dispatch(actionHandelRemoveAllItemInBasketCart());
                        break;
                    case 1:
                        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
                            okPaymentEdit(response.data.order);
                        else
                            okPayment(response.data.order);
                        break;
                    case 2:
                        if (response.data.price <= 0) {
                            if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
                                okPaymentEdit(response.data.order);
                            else
                                okPayment(response.data.order);
                        } else {
                            if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
                                window.open(BASE_URL + PAYMENT_EDIT_ORDER_PAY + `?order=${response.data.order * 123}&amount=${response.data.price}&token=${token}`, "_self");
                            else
                                window.open(BASE_URL + PAYMENT_PAY + `?order=${response.data.order * 123}&amount=${response.data.price}&token=${token}`, "_self");
                        }
                        break;
                    default:
                }
            } else if (response.data.status === 'error') {
                swal({
                    title: "ثبت سفارش ناموفق",
                    text: response.data.message,
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "error",
                });
            }
            dispatch(actionChangeLoaderInvoiceModalShoppingCard(false));
        }));


    };

    const handleClose = () => {
        handleRemoveDiscountCode();
        dispatch(actionRefreshModalAddDiscountCode());
        dispatch(handelCloseModalShoppingCard());
    };

    const handleRemoveDiscountCode = () => {
        dispatch(actionChangeInputsModalAddDiscountCode('statusSet', false));
        dispatch(actionChangeInputsModalAddDiscountCode('discountCode', ''));
    }

    

    const renderBtns = () => {
        switch (parseInt(invoice.pay_type)) {
            case 1:
                return (
                    <Col xs={12} className={'mt-1'}>
                        <Button variant="success" className={'base-btn-green btn-sm'} block disabled={statusLoaderPrice}
                                onClick={handelAddressPaymentShoppingCard}>
                            <span>پرداخت در محل</span>
                            {statusLoaderPrice && payTypeClick === 1 ?
                                <Spinner className={'float-right mb-1 ml-2'}
                                         animation="border" size="sm"
                                         variant="danger"/>
                                : ''
                            }
                        </Button>
                    </Col>
                );
            case 2:
                return (
                    <Col xs={12} className={'mt-1'}>
                        <Button variant="success" className={'base-btn-green btn-sm'} block disabled={statusLoaderPrice}
                                onClick={handelOnlinePaymentShoppingCard}>
                            <span>پرداخت آنلاین</span>
                            {statusLoaderPrice && payTypeClick === 2 ?
                                <Spinner className={'float-right mb-1 ml-2'}
                                         animation="border" size="sm"
                                         variant="danger"/>
                                : ''
                            }
                        </Button>
                    </Col>
                );
            case 3:
                return (
                    <React.Fragment>
                        <Col xs={6} className={'mt-1'}>
                            <Button variant="success" className={'base-btn-green btn-sm'} block
                                    disabled={statusLoaderPrice}
                                    onClick={handelAddressPaymentShoppingCard}>
                                <span>پرداخت در محل</span>
                                {statusLoaderPrice && payTypeClick === 1 ?
                                    <Spinner className={'float-right mb-1 ml-2'}
                                             animation="border" size="sm"
                                             variant="danger"/>
                                    : ''}
                            </Button>
                        </Col>
                        <Col xs={6} className={'mt-1'}>
                            <Button variant="success" className={'base-btn-green btn-sm'} block
                                    disabled={statusLoaderPrice}
                                    onClick={handelOnlinePaymentShoppingCard}>
                                <span>پرداخت آنلاین</span>
                                {statusLoaderPrice && payTypeClick === 2 ?
                                    <Spinner className={'float-right mb-1 ml-2'}
                                             animation="border" size="sm"
                                             variant="danger"/>
                                    : ''
                                }
                            </Button>
                        </Col>
                    </React.Fragment>

                );
            default:
        }
    };

    const openModalAddDiscountCode = () => {
        dispatch(actionChangeHandelModalAddDiscountCode(true));
    }

    const okPayment = (order) => {
        handleClose();
        btnOkSingle.fire({
            title: "سفارش با موفقیت ثبت شد",
            text: `فاکتور ${order} صادر شد  و به آدرس انتخابی ارسال میگردد`,
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "تایید",
        });
        dispatch(actionHandelRemoveAllItemInBasketCart());
    }

    const okPaymentEdit = (order) => {
        handleClose();
        swal({
            title: "ثبت موفق تغییرات",
            text: `فاکتور ${order} با موفقیت ویرایش شد.`,
            buttons: {
                cancel: "تایید",
            },
            icon: "success",
        });
        dispatch(actionHandelRemoveAllItemInBasketCart());
        localStorage.removeItem("editOrderMode");
        dispatch(actionRefreshModalShoppingCard());
        history.push('/stores');
    }

    return (
        <Row className={'w-100 m-auto'}>
            <Col xs={12}>
                <div className={'text-center mb-1'}>
                    <div className={'add-price-in-modal-my-wallet'} onClick={openModalAddDiscountCode}>
                        <FaPlus className={'icon-plus-add-price-modal-wallet'}/>
                        <span className={'txt-plus-add-price-modal-wallet'}>
                            {statusSet && amount ? (amount.search("%") !== -1 ? amount : (parseInt(amount).toLocaleString() + ' تومان')) + '  تخفیف اعمال شد' : 'ورود کد تخفیف'}
                        </span>
                    </div>
                </div>
            </Col>
            {renderBtns()}

            <Col xs={6} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green btn-sm'} block
                        onClick={handelWalletPaymentShoppingCard}
                        disabled={statusLoaderPrice || invoice.wallet_credit <= 0 || (invoice.wallet_credit === 0 && statusAddWalletItemInInvoice())}
                >
                    {statusLoaderPrice && payTypeClick === 'wallet' ?
                        <Spinner className={'float-right mb-1 ml-2'}
                                 animation="border" size="sm"
                                 variant="danger"/>
                        : ''
                    }
                    <span>پرداخت از کیف پول</span>
                    <br />
                    <span>موجودی  ({statusAddWalletItemInInvoice() ? invoice.wallet_credit.toLocaleString() + ' تومان' : 0}) </span>
                </Button>
            </Col>
            <Col xs={6} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green-border btn-sm'} style={{minHeight: "100%"}} block
                        onClick={handelPrevLevelShoppingCard} disabled={statusLoaderPrice}>
                    <span>مرحله قبلی</span>
                </Button>
            </Col>
        </Row>
    );
};

export default memo(InvoiceFooter);
